import React from 'react';
import { Typography, Button, Paper, Stack } from '@mui/material';
import { FeatureFlags } from '../../flags';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import ResponsiveLayout from './ResponsiveLayout';
import { KEYSTONE_REDIRECT_URL } from '../../config';
import { navigateTo } from '../../utils';
import { useTenant } from '../../contexts/TenantContext';

const ListingManagementGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { hasFeature } = useFeatureFlags();
  const { isAddEditHost } = useTenant();

  const isSaas = isAddEditHost();

  if (!hasFeature(FeatureFlags.NEXT_GENERATION_LISTING_MANAGEMENT)) {
    return (
      <ResponsiveLayout>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            pb: isSaas ? 0 : 4,
            maxWidth: 600,
            textAlign: 'center',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ color: 'secondary.medium' }}
          >
            Listing Management Not Available
          </Typography>

          <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
            {isSaas
              ? 'Please reach out to your administrator for support enabling listing management.'
              : 'The Next Generation Listing Management feature is not currently\n' +
                '            enabled for your account. Please reach out to Bright Support for\n' +
                '            assistance.'}
          </Typography>

          {!isSaas && (
            <Stack spacing={2} direction="row" justifyContent="center">
              <Button
                variant="outlined"
                onClick={() => navigateTo(KEYSTONE_REDIRECT_URL)}
                sx={{
                  color: 'secondary.medium',
                  borderColor: 'secondary.medium',
                  '&:hover': {
                    backgroundColor: 'rgba(37, 55, 114, 0.04)',
                    borderColor: 'secondary.medium',
                  },
                }}
              >
                Go to Legacy Listing Management
              </Button>

              <Button
                variant="contained"
                href="https://support.brightmls.com/s/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Bright Support
              </Button>
            </Stack>
          )}
        </Paper>
      </ResponsiveLayout>
    );
  }

  return <>{children}</>;
};

export default ListingManagementGate;
